import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { environment } from 'src/environments/environment';
import { InvoiceResponse } from 'src/app/shared/model/invoice.model';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getInvoiceDetailsById(InvoiceId: number): Observable<InvoiceResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.GET_SINGLE_INVOICE}${InvoiceId}`;
    return this.http
      .get<InvoiceResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
